import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import moment from 'moment'
import {
  Div, P, Loading, Input,
} from 'konsys-ui'
import {
  DatePicker, Col, Collapse,
} from 'antd'
import numeral from 'numeral'
import detailType from '../util-functions'
import { DRIVER_INFO } from '../../../constants/graphql/query'
import { CREATE_SALARY_DRIVER } from '../../../constants/graphql/mutation'
import { PaymentActionBar, Wrapper } from '../../../components/driver-components'
import { theme } from '../../../styles/_variables'
import { checkFloat } from '../../../utils/util-services'

const { color } = theme

const { Panel } = Collapse

const Index = ({ props }) => {
  const [salary, setSalary] = useState('waitForLoading')
  const [date, setDate] = useState()
  const [otTime, setOtTime] = useState(0)
  const [holidayTime, setHolidayTime] = useState(0)
  const [holidayOtTime, setHolidayOtTime] = useState(0)
  const [mutationVariables, setMutationVariables] = useState({
    fieldWork: 0,
    depositRefund: 0,
    annualBonus: 0,
    otherIncome: 0,
    absence: 0,
    depositPay: 0,
    cooperativeShare: 0,
    cooperativeLoan: 0,
    withholdingTax: 0,
    socialSecurity: 497,
    waterBill: 0,
    electricBill: 0,
    ticketFines: 0,
    phoneBill: 0,
    damageCompensation: 0,
    gasCost: 0,
    airconditionBill: 0,
    shortWeight: 0,
    accountFee: 0,
    transferFee: 0,
    uniformCost: 0,
    otherCost: 0,
  })
  return (
    <Div display='flex' flexDirection='column'>
      {
        <Query
          query={DRIVER_INFO}
          variables={{
            id: props.match.params.id,
          }}
        >
          {
            ({
              data: driver, error: driverError, loading: driverLoading,
            }) => {
              if (driverLoading && _.isEmpty(driver)) return <Loading />
              if (driverError) return <P>เกิดข้อผิดพลาด</P>
              const info = driver.DriverInfo.driver
              if (salary === 'waitForLoading') {
                setSalary(info.salary)
                setMutationVariables({
                  ...mutationVariables,
                  salary: info.salary,
                  // socialSecurity: info.salary * 5 / 100 > 750 ? 750 : info.salary * 5 / 100,
                })
              }
              return (
                <Div>
                  <Mutation
                    mutation={CREATE_SALARY_DRIVER}
                  >{(doAction, { loading }) => (
                    <Div>
                      <Wrapper>
                        <Div display='flex' flexDirection='column' alignItems='flex-start' alignSelf='flex-start'>
                          <P>ชื่อ - นามสกุล *</P>
                          <P bold margin='16px 0 0'>{info.fullname}</P>
                        </Div>
                      </Wrapper>
                      <Div>
                        <Wrapper>
                          <Div display='flex' flexDirection='row' margin='0 0 16px' >
                            {/* Month */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>เลือกเดือน *</P>
                            </Col>
                            <Col span={6}>
                              <DatePicker.MonthPicker
                                placeholder='เลือกเดือน'
                                allowClear={false}
                                style={{ width: '400px' }}
                                onChange={(e) => {
                                  setDate(moment(e).startOf('month'))
                                }}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* salary */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>เงินเดือน *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='400px'
                                value={mutationVariables.salary}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                onChange={(e) => {
                                  setSalary(_.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value))
                                  setMutationVariables({
                                    ...mutationVariables,
                                    salary: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                    // socialSecurity: e.target.value * 5 / 100 > 750 ? 750 : e.target.value * 5 / 100,
                                  })
                                }}
                              />
                            </Col>
                          </Div>
                        </Wrapper>
                        <Wrapper>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* OT */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าล่วงเวลา</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={otTime}
                                onChange={(e) => {
                                  setOtTime(_.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value))
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>ชั่วโมง</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={4}>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={numeral(otTime * 1.5 * salary / 30 / 8).format('0,0.00')}
                                disabled={true}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* holidayPay */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ทำงานวันหยุด</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={holidayTime}
                                onChange={(e) => {
                                  setHolidayTime(_.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value))
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>ชั่วโมง</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={4}>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={numeral(holidayTime * salary / 30 / 8).format('0,0.00')}
                                disabled={true}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* holidayOTPay */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าล่วงเวลาวันหยุด</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={holidayOtTime}
                                onChange={(e) => {
                                  setHolidayOtTime(_.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value))
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>ชั่วโมง</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={4}>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={numeral(holidayOtTime * 3 * salary / 30 / 8).format('0,0.00')}
                                disabled={true}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* fieldWork */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>งานนอก</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.fieldWork}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    fieldWork: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* depositRefund */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>คืนเงินประกัน</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.depositRefund}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    depositRefund: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* annualBonus */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>เงินโบนัสประจำปี</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.annualBonus}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    annualBonus: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* otherIncome */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>รายได้อื่นๆ</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.otherIncome}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    otherIncome: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                        </Wrapper>
                        <Wrapper>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* absence */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ขาดงาน</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.absence}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    absence: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* depositPay */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>หักเงินประกัน</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.depositPay}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    depositPay: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* cooperativeShare */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>หุ้นสหกรณ์หักเข้า</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.cooperativeShare}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    cooperativeShare: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* cooperativeLoan */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>หักเงินกู้สหกรณ์</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.cooperativeLoan}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    cooperativeLoan: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* withholdingTax */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ภาษีหัก ณ ที่จ่าย</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.withholdingTax}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    withholdingTax: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* socialSecurity */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ประกันสังคม</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.socialSecurity}
                                // disabled={true}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    socialSecurity: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* waterBill */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าน้ำ</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.waterBill}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    waterBill: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* electricBill */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าไฟ</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.electricBill}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    electricBill: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* ticketFines */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าปรับตามใบสั่ง</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.ticketFines}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    ticketFines: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* phoneBill */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าโทรศัพท์</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.phoneBill}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    phoneBill: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* damageCompensation */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าชดเชยทรัพย์สินเสียหาย</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.damageCompensation}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    damageCompensation: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* gasCost */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>หักค่าน้ำมัน</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.gasCost}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    gasCost: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* airconditionBill */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าซ่อมแอร์</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.airconditionBill}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    airconditionBill: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* shortWeight */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าน้ำหนักขาด</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.shortWeight}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    shortWeight: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* accountFee */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าเปิดบัญชี</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.accountFee}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    accountFee: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* transferFee */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ค่าธรรมเนียมหักบัญชี</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.transferFee}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    transferFee: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* uniformCost */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>หักค่าเครื่องแบบหนักงาน</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.uniformCost}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    uniformCost: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* otherCost */}
                            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                              <P>ส่วนหักอื่นๆ</P>
                            </Col>
                            <Col span={6}>
                              <Input width='350px'
                                value={mutationVariables.otherCost}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    otherCost: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                              <P margin='0 0 0 10px'>บาท</P>
                            </Col>
                          </Div>
                        </Wrapper>
                        {/* calculate info */}
                        <Wrapper>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={6}>
                              <Div display='flex' flexDirection='row' justifyContent='space-between'>
                                <P>เงินเดือน</P>
                                <P>{numeral(mutationVariables.salary).format('0,0.00')} บาท</P>
                              </Div>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={6}>
                              <Div display='flex' flexDirection='row' justifyContent='space-between'>
                                <P>รายได้พิเศษ</P>
                                <P>+ {numeral(otTime * 1.5 * salary / 30 / 8
                                  + holidayTime * salary / 30 / 8
                                  + holidayOtTime * 3 * salary / 30 / 8
                                  + mutationVariables.fieldWork
                                  + mutationVariables.depositRefund
                                  + mutationVariables.annualBonus
                                  + mutationVariables.otherIncome).format('0,0.00')} บาท</P>
                              </Div>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={6}>
                              <Div display='flex' flexDirection='row' justifyContent='space-between' style={{ borderBottom: '0.6px solid #B8B8B8' }}>
                                <P>ส่วนหัก</P>
                                <P>- {numeral(mutationVariables.absence
                                  + mutationVariables.depositPay
                                  + mutationVariables.cooperativeShare
                                  + mutationVariables.cooperativeLoan
                                  + mutationVariables.withholdingTax
                                  + mutationVariables.socialSecurity
                                  + mutationVariables.waterBill
                                  + mutationVariables.electricBill
                                  + mutationVariables.ticketFines
                                  + mutationVariables.phoneBill
                                  + mutationVariables.damageCompensation
                                  + mutationVariables.gasCost
                                  + mutationVariables.airconditionBill
                                  + mutationVariables.shortWeight
                                  + mutationVariables.accountFee
                                  + mutationVariables.transferFee
                                  + mutationVariables.uniformCost
                                  + mutationVariables.otherCost).format('0,0.00')} บาท</P>
                              </Div>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={6}>
                              <Div display='flex' flexDirection='row' justifyContent='space-between' style={{ borderBottom: '0.6px solid #000000' }}>
                                <P bold>รายได้สุทธิ</P>
                                <P bold>{numeral(mutationVariables.salary + (otTime * 1.5 * salary / 30 / 8
                                  + holidayTime * salary / 30 / 8
                                  + holidayOtTime * 3 * salary / 30 / 8
                                  + mutationVariables.fieldWork
                                  + mutationVariables.depositRefund
                                  + mutationVariables.annualBonus
                                  + mutationVariables.otherIncome) - (mutationVariables.absence
                                  + mutationVariables.depositPay
                                  + mutationVariables.cooperativeShare
                                  + mutationVariables.cooperativeLoan
                                  + mutationVariables.withholdingTax
                                  + mutationVariables.socialSecurity
                                  + mutationVariables.waterBill
                                  + mutationVariables.electricBill
                                  + mutationVariables.ticketFines
                                  + mutationVariables.phoneBill
                                  + mutationVariables.damageCompensation
                                  + mutationVariables.gasCost
                                  + mutationVariables.airconditionBill
                                  + mutationVariables.shortWeight
                                  + mutationVariables.accountFee
                                  + mutationVariables.transferFee
                                  + mutationVariables.uniformCost
                                  + mutationVariables.otherCost
                                )).format('0,0.00')} บาท</P>
                              </Div>
                            </Col>
                          </Div>
                        </Wrapper>
                      </Div>
                      <PaymentActionBar
                        loading={loading}
                        disabled={
                          _.isUndefined(date) || _.isUndefined(mutationVariables.salary)
                        } // condition here
                        doAction={doAction}
                        mutationVariables={{
                          ...mutationVariables,
                          driverId: parseInt(props.match.params.id, 10),
                          periodStart: moment(date).startOf('month').format('YYYY-MM-DD'),
                          periodEnd: moment(date).endOf('month').format('YYYY-MM-DD'),
                          overtime: otTime * 1.5 * salary / 30 / 8,
                          holidayPay: holidayTime * salary / 30 / 8,
                          holidayOvertime: holidayOtTime * 3 * salary / 30 / 8,
                          netSalary: mutationVariables.salary + (otTime * 1.5 * salary / 30 / 8
                            + holidayTime * salary / 30 / 8
                            + holidayOtTime * 3 * salary / 30 / 8
                            + mutationVariables.fieldWork
                            + mutationVariables.depositRefund
                            + mutationVariables.annualBonus
                            + mutationVariables.otherIncome) - (mutationVariables.absence
                            + mutationVariables.depositPay
                            + mutationVariables.cooperativeShare
                            + mutationVariables.cooperativeLoan
                            + mutationVariables.withholdingTax
                            + mutationVariables.socialSecurity
                            + mutationVariables.waterBill
                            + mutationVariables.electricBill
                            + mutationVariables.ticketFines
                            + mutationVariables.phoneBill
                            + mutationVariables.damageCompensation
                            + mutationVariables.gasCost
                            + mutationVariables.airconditionBill
                            + mutationVariables.shortWeight
                            + mutationVariables.accountFee
                            + mutationVariables.transferFee
                            + mutationVariables.uniformCost
                            + mutationVariables.otherCost
                          ),
                        }}
                        props={props}
                      />
                    </Div>
                  )}
                  </Mutation>
                </Div>
              )
            }
          }
        </Query>
      }
    </Div>
  )
}

export default Index
export { Index }
